import { cn } from '@/utilities/ui'
import aboutOff from '../svgs/icon_nav_dd_about_off.svg'
import aboutOn from '../svgs/icon_nav_dd_about_on.svg'
import grantsOff from '../svgs/icon_nav_dd_grants_off.svg'
import grantsOn from '../svgs/icon_nav_dd_grants_on.svg'
import projectsToolsOff from '../svgs/icon_nav_dd_projects_tools_off.svg'
import projectsToolsOn from '../svgs/icon_nav_dd_projects_tools_on.svg'
import provideStorageOff from '../svgs/icon_nav_dd_provide_storage_off.svg'
import provideStorageOn from '../svgs/icon_nav_dd_provide_storage_on.svg'
import roadmapOff from '../svgs/icon_nav_dd_roadmap_off.svg'
import roadmapOn from '../svgs/icon_nav_dd_roadmap_on.svg'
import storeDataOff from '../svgs/icon_nav_dd_store_data_off.svg'
import storeDataOn from '../svgs/icon_nav_dd_store_data_on.svg'
import techOverviewOff from '../svgs/icon_nav_dd_tech_overview_off.svg'
import techOverviewOn from '../svgs/icon_nav_dd_tech_overview_on.svg'
import whitepaperOff from '../svgs/icon_nav_dd_whitepaper_off.svg'
import whitepaperOn from '../svgs/icon_nav_dd_whitepaper_on.svg'

import impenetrableSecurity from '../svgs/icon_impenetrable_security.svg'
import continuousPerformance from '../svgs/icon_continuous_performance.svg'
import nonprofitModel from '../svgs/icon_non-profit_model.svg'
import supremePrivacy from '../svgs/icon_supreme_privacy.svg'
import decentralizedDesign from '../svgs/icon_decentralized_design.svg'

type Props = {
  icon:
    | 'about'
    | 'grants'
    | 'projects_tools'
    | 'provide_storage'
    | 'roadmap'
    | 'store_data'
    | 'use_storage'
    | 'tech_overview'
    | 'whitepaper'
    | 'impenetrable_security'
    | 'continuous_performance'
    | 'nonprofit_model'
    | 'supreme_privacy'
    | 'decentralized_design'
    | string
  className?: string
  containerClassName?: string
}

const iconMap = {
  about: {
    on: aboutOn,
    off: aboutOff,
  },
  grants: {
    on: grantsOn,
    off: grantsOff,
  },
  projects_tools: {
    on: projectsToolsOn,
    off: projectsToolsOff,
  },
  provide_storage: {
    on: provideStorageOn,
    off: provideStorageOff,
  },
  roadmap: {
    on: roadmapOn,
    off: roadmapOff,
  },
  store_data: {
    on: storeDataOn,
    off: storeDataOff,
  },
  tech_overview: {
    on: techOverviewOn,
    off: techOverviewOff,
  },
  whitepaper: {
    on: whitepaperOn,
    off: whitepaperOff,
  },
  impenetrable_security: {
    on: impenetrableSecurity,
    off: impenetrableSecurity,
  },
  continuous_performance: {
    on: continuousPerformance,
    off: continuousPerformance,
  },
  nonprofit_model: {
    on: nonprofitModel,
    off: nonprofitModel,
  },
  supreme_privacy: {
    on: supremePrivacy,
    off: supremePrivacy,
  },
  decentralized_design: {
    on: decentralizedDesign,
    off: decentralizedDesign,
  },
}

export function AbstractIcon({ icon, containerClassName, className }: Props) {
  const classes = cn('relative w-[24px] h-[24px]', className)
  const onIcon = iconMap[icon as keyof typeof iconMap] || iconMap.about
  return (
    <div className={containerClassName}>
      <img src={onIcon.on.src} alt={icon} className={classes} />
    </div>
  )
}
